var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4 2C15.6 3.1 15.1 4.2 14.5 5C13.9 5.8 12.8 6.5 11.7 6.4C11.5 5.3 12 4.3 12.6 3.5C13.3 2.7 14.4 2.1 15.4 2ZM18.6 19.4C19.1 18.6 19.4 18.1 19.8 17.2C16.7 16 16.2 11.6 19.3 10C18.4 8.8 17.1 8.2 15.8 8.2C14.9 8.2 14.3 8.4 13.7 8.6C13.2 8.8 12.8 8.9 12.3 8.9C11.7 8.9 11.3 8.7 10.7 8.5C10.1 8.3 9.50004 8.1 8.80004 8.1C7.40004 8.1 5.90004 8.9 5.00004 10.4C3.70004 12.4 3.90004 16.3 6.00004 19.5C6.90004 20.7 7.90004 22 9.20004 22C9.80004 22 10.1 21.8 10.5 21.7C11 21.5 11.5 21.3 12.3 21.3C13.2 21.3 13.6 21.5 14.1 21.7C14.5 21.9 14.8 22 15.4 22C16.8 22 17.8 20.5 18.6 19.4Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.d37f21f36ed524c8b1e79d70547e9aae.svg";
export { ForwardRef as ReactComponent };